import React     from 'react'
import Form from '../Form/Form'
import { useTranslation} from 'react-i18next';

const FormNousContacter = () => {

    const { t } = useTranslation();

    return (
        <div>
            <h1 className="h1 text-center mt-3"> {t('Form.ContactUs')}</h1>
            <div className="bg-bordeaux mx-auto" style={{height: "6px", width: "100px"}}></div>

                <div className="my-5 container p-5 border">
                    <Form />
                </div>
        </div>
    )
}

export default FormNousContacter
